import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// ========== SCSS ==========
import '../scss/directory.scss';

// ========== ELEMENTS ==========
import DirectoryItem from '../elements/DirectoryItem';
import FileItem from '../elements/FileItem';

export class Directory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: ''
    };
  }

  handleChange(e) {
    const value = e.target.value;
    this.setState({
      ...this.state,
      [e.target.name]: value
    });
  }

  getFileElements(fileList) {
    let elements = [];
    fileList.forEach((file, i) => {
      if ((this.state.search == null || this.state.search == '') || window.normalizeString(file.name).includes(window.normalizeString(this.state.search)))
        elements.push(
          <li key={i}>
            <FileItem
              id={file.id}
              name={file.name}
              type={file.type}
              directory_type={this.props.type}
              source={file.source}
              thumbnail={file.thumbnail}
              rendered={file.rendered}
            />
          </li>
        );
    });

    return elements;
  }

  getDirectoryElements(directoryList) {
    let elements = [];
    directoryList.forEach((dir, i) => {
      elements.push(
        <DirectoryItem
          key={dir.id}
          id={dir.id}
          name={dir.name}
          type={dir.type}
          content={dir.content}
          parent_directory={{
            id: this.props.id,
            name: this.props.name,
            type: this.props.type,
          }}
        />
      );
    });

    return elements;
  }

  getDirectoryStructure() {
    let header = null;
    if (this.props.type == 'search' || this.props.type == 'gallery') {
      header = (
        <div className="header-container">
          <form className="search-form" id="searchForm" role="search">
            <div className="content">
              <button id="searchsubmit" value="Busca" onClick={(e) => { e.preventDefault() }}>
                <svg xmlns="http://www.w3.org/2000/svg" height="18pt" version="1.1" viewBox="-1 0 136 136.21852" width="18pt">
                  <g id="surface1">
                    <path d="M 93.148438 80.832031 C 109.5 57.742188 104.03125 25.769531 80.941406 9.421875 C 57.851562 -6.925781 25.878906 -1.460938 9.53125 21.632812 C -6.816406 44.722656 -1.351562 76.691406 21.742188 93.039062 C 38.222656 104.707031 60.011719 105.605469 77.394531 95.339844 L 115.164062 132.882812 C 119.242188 137.175781 126.027344 137.347656 130.320312 133.269531 C 134.613281 129.195312 134.785156 122.410156 130.710938 118.117188 C 130.582031 117.980469 130.457031 117.855469 130.320312 117.726562 Z M 51.308594 84.332031 C 33.0625 84.335938 18.269531 69.554688 18.257812 51.308594 C 18.253906 33.0625 33.035156 18.269531 51.285156 18.261719 C 69.507812 18.253906 84.292969 33.011719 84.328125 51.234375 C 84.359375 69.484375 69.585938 84.300781 51.332031 84.332031 C 51.324219 84.332031 51.320312 84.332031 51.308594 84.332031 Z M 51.308594 84.332031 " style={{stroke: 'none', fillRule: 'nonzero', fillOpacity: 1}} />
                  </g>
                </svg>
              </button>
              <input type="text" name="search" placeholder="Pesquisar" required value={this.state.search} onChange={(e) => {this.handleChange(e)}} />
            </div>
          </form>
          <Link className="btn" to={'/registry/file/' + this.props.id}>Enviar arquivo...</Link>
        </div>
      );
    }

    let content = (
      <div className={'content ' + (this.props.type != null ? this.props.type : 'default')}>
        { this.getDirectoryElements(this.props.directory_list) }
        <ul className="file-list">
          { this.getFileElements(this.props.file_list) }
        </ul>
        {
          (this.props.type == 'gallery')
            ? <div id="galleryContainer" onClick={(e) => {

                e.target.classList.remove('active');

              }}>
                <img src="" onClick={(e) => {

                  e.target.parentElement.classList.remove('active');

                }}/>
              </div>
            : null
        }
      </div>
    );

    let controllers = (
      this.props.privileges != null
        ? <div className="directory-controllers row">
            <div className="column">
              {
                (this.props.privileges.edit && this.props.parent_directory != null)
                  ? <Link
                      className="btn"
                      to={{
                        pathname: '/registry/directory/' + this.props.parent_directory.id,
                        dir_info: {
                          id: this.props.id,
                          name: this.props.name,
                          type: this.props.type
                        }
                      }}
                    >
                      Editar...
                    </Link>
                  : null
              }
              {
                (this.props.privileges.edit)
                  ? <Link className="btn" to={'/registry/directory/' + this.props.id}>Nova pasta...</Link>
                  : null
              }
              {
                (this.props.privileges.edit && this.props.type != 'search' && this.props.type != 'gallery' && this.props.type != 'states')
                  ? <Link className="btn" to={'/registry/file/' + this.props.id}>Enviar arquivo...</Link>
                  : null
              }
              {
                (this.props.privileges.delete && this.props.parent_directory != null)
                  ? <button
                      className="btn red"
                      onClick={async (e) => {
                        if (window.confirm('Apagar pasta? (todo o conteúdo também será removido)')) {
                          let response = await window.doRequest('POST', {
                            action: 'deleteDirectory',
                            token: sessionStorage.getItem('token'),
                            id: this.props.id
                          });

                          if (response.status) {

                            if (this.props.parent_directory != null)
                              this.props.history.push('/directory/' + this.props.parent_directory.id);
                            else
                              this.props.history.push('/');

                          } else
                              window.alert(response.message);
                        }
                      }}
                    >
                      Apagar pasta
                    </button>
                  : null
              }
            </div>
            <div className="column">
              {
                (this.props.privileges.edit)
                  ? <Link
                      className="btn purple"
                      to={'/privileges/' + this.props.id}
                    >
                      Privilégios de acesso
                    </Link>
                  : null
              }
            </div>
          </div>
        : null
    );

    return (
      <div className="dir-container">
        { header }
        { content }
        { controllers }
      </div>
    );
  }

  render() {
    return (
      <div id="directory">
        <div className="dir-title">
          {
            (this.props.parent_directory != null)
              ? <span>{this.props.parent_directory.name}</span>
              : null
          }
          <h1 className="title">{this.props.name}</h1>
          {
            (this.props.parent_directory != null)
              ? <div className="back-btn-container">
                  <button className="back-btn" onClick={(e) => {
                    this.props.history.push('/directory/' + this.props.parent_directory.id)
                  }}>
                    Voltar
                  </button>
                </div>
              : null
          }
        </div>
        { this.getDirectoryStructure() }
      </div>
    );
  }
}

export default Directory
